<script setup lang="ts">
import type { MaybeElementRef } from '@vueuse/core';
import { onClickOutside } from '@vueuse/core';
import type { MaybeRefOrGetter } from 'vue';
import { useTemplateRef } from 'vue';

import type {
  GrammarMenuItemProps,
} from '@nora-monorepo/grammar-ui';
import {
  GrammarMenu,
  GrammarMenuItem,
} from '@nora-monorepo/grammar-ui';

interface Props {
  ignoredClickOutsideElements?: MaybeRefOrGetter<(MaybeElementRef | string)[]>;
  menuItems?: GrammarMenuItemProps[];
}
const props = withDefaults(defineProps<Props>(), {
  ignoredClickOutsideElements: () => [],
  menuItems: () => [],
});

const emit = defineEmits(['close']);

const userMenu = useTemplateRef<HTMLElement>('userMenu');

onClickOutside(
  userMenu,
  () => {
    emit('close');
  },
  {
    ignore: props.ignoredClickOutsideElements,
  },
);
</script>

<template>
  <GrammarMenu ref="userMenu" :is-open="true">
    <GrammarMenuItem v-for="(item, ix) in menuItems" :key="ix" v-bind="item" />
  </GrammarMenu>
</template>
